var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#28519E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8335 16.532C24.8335 19.404 22.4691 21.732 19.5522 21.732H14.9454L17.456 24.204L16.3022 25.332L11.8335 20.932L16.3022 16.532L17.4479 17.66L14.9454 20.132H19.5522C21.5835 20.132 23.2085 18.532 23.2085 16.532C23.2085 14.532 21.5835 12.932 19.5522 12.932H13.4585V11.332H19.5522C22.4691 11.332 24.8335 13.66 24.8335 16.532Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevoke);
export default __webpack_public_path__ + "static/media/Revoke.1b7be09238641ba59c118ac2c1c00033.svg";
export { ForwardRef as ReactComponent };